import { useRef } from "react";
import { useTranslation } from "react-i18next";
import type { BetCurrency } from "./betSettings.js";

export function BetFooter({
  value,
  onChange,
  disabled,
  max,
  currency,
}: {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  max: number | undefined;
  currency: BetCurrency | undefined;
}) {
  const { t } = useTranslation();
  const previous = useRef("1.01");
  return (
    <div className="cx-bet-footer">
      <div className="cx-cashout-switch">
        <input
          type="checkbox"
          role="switch"
          checked={value !== ""}
          disabled={disabled}
          aria-label={t("bet.autoCashoutToggle")}
          onChange={(event) => {
            if (value !== "") previous.current = value;
            onChange(event.target.checked ? previous.current : "");
          }}
        />
        <span>{t("bet.autoCashout")}</span>
      </div>
      <input
        className="cx-input cx-cashout-value"
        type="number"
        inputMode="decimal"
        min={1.01}
        max={max}
        step={0.01}
        aria-label={t("bet.autoCashout")}
        placeholder={t("bet.autoCashoutOff")}
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      />
      {currency ? (
        <span className="cx-bet-limits">
          {t("bet.min", { amount: currency.minBet })} · {t("bet.max", { amount: currency.maxBet })}
        </span>
      ) : null}
    </div>
  );
}
